import { render, staticRenderFns } from "./AdminArticles.vue?vue&type=template&id=02eabcbe&scoped=true"
import script from "./AdminArticles.vue?vue&type=script&lang=js"
export * from "./AdminArticles.vue?vue&type=script&lang=js"
import style0 from "./AdminArticles.vue?vue&type=style&index=0&id=02eabcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eabcbe",
  null
  
)

export default component.exports